import { useState } from "react";
import { Link } from "react-router-dom";
import type { Episode } from "@/types";

interface EpisodeActionsProps {
  episode: Episode;
  isFavorite: boolean;
  onToggleFavorite: () => void;
  prev?: Episode;
  next?: Episode;
}

export default function EpisodeActions({
  episode,
  isFavorite,
  onToggleFavorite,
  prev,
  next,
}: EpisodeActionsProps) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <button
        type="button"
        onClick={onToggleFavorite}
        className={`inline-flex items-center gap-2 whitespace-nowrap rounded-md px-4 py-2.5 font-label text-sm font-medium transition-colors ${
          isFavorite
            ? "bg-accent-500 text-primary-950 hover:bg-accent-400"
            : "border border-background-300 bg-background-50 text-foreground-700 hover:border-accent-400 hover:text-accent-700"
        }`}
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className={isFavorite ? "ri-heart-fill text-base leading-none" : "ri-heart-line text-base leading-none"}></i>
        </span>
        {isFavorite ? "已收藏" : "收藏本集"}
      </button>

      <button
        type="button"
        onClick={handleShare}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className={copied ? "ri-check-line text-base leading-none" : "ri-share-line text-base leading-none"}></i>
        </span>
        {copied ? "链接已复制" : "分享本集"}
      </button>

      <div className="ml-auto flex items-center gap-2">
        {prev ? (
          <Link
            to={`/detail/${prev.id}`}
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2.5 font-label text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-left-s-line text-base leading-none"></i>
            </span>
            上一集
          </Link>
        ) : (
          <span className="inline-flex items-center rounded-md border border-background-200 px-3 py-2.5 font-label text-sm text-foreground-300">
            已是第一集
          </span>
        )}
        {next ? (
          <Link
            to={`/detail/${next.id}`}
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-700 px-3 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-800"
          >
            下一集
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-s-line text-base leading-none"></i>
            </span>
          </Link>
        ) : (
          <span className="inline-flex items-center rounded-md border border-background-200 px-3 py-2.5 font-label text-sm text-foreground-300">
            已更新至最新
          </span>
        )}
      </div>
    </div>
  );
}